// No-op stub for posthog-js/react — no PostHogProvider is set up in teams.
// Without this stub usePostHog() returns undefined causing runtime errors when
// terminal source calls posthogClient methods (reset, onFeatureFlags, etc.).

const noop = (): void => {};

const noopClient = {
  reset: noop,
  identify: noop,
  capture: noop,
  setPersonProperties: noop,
  // useFlags.ts calls these after initFlagsStore(posthogClient)
  onFeatureFlags: (_callback: () => void): void => {},
  reloadFeatureFlags: noop,
  featureFlags: {
    getFlagsWithDetails: (): Record<string, unknown> => ({}),
  },
};

export const usePostHog = () => noopClient;
export const PostHogProvider = ({ children }: { children: unknown }) =>
  children;
export const PostHogContext = null;
